export default __webpack_public_path__ + "static/media/platform-assets.578cd942.svg";